"use client";

import { c as _c } from "react/compiler-runtime";
import { ConsentWelcomeIos } from "./ios";
import { ConsentWelcomeAndroid } from "./android";
import { ConsentWelcomeWeb } from "./web";
import { useThemeStore } from "@/store/theme-store";
const platformComponents = {
  ios: ConsentWelcomeIos,
  android: ConsentWelcomeAndroid,
  web: ConsentWelcomeWeb
};
export const ConsentWelcome = () => {
  const $ = _c(2);
  const platform = useThemeStore(_temp);
  const Component = platformComponents[platform];
  let t0;
  if ($[0] !== Component) {
    t0 = <Component className="h-full w-full" />;
    $[0] = Component;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(state) {
  return state.platform;
}